import { Collapse, CollapseProps } from 'antd';
import cn from 'classnames';
import * as React from 'react';

import s from './CustomDrawerBody.module.scss';

export type CustomDrawerBodyProps = React.PropsWithChildren<{
  onClick?: React.MouseEventHandler;
  className?: string;
  onScroll?: React.HTMLProps<HTMLDivElement>['onScroll'];
  header?: React.ReactNode;
  collapse?:
    | boolean
    | {
        expandIcon: CollapseProps['expandIcon'];
      };
}>;

const CustomDrawerBody = React.forwardRef<
  HTMLDivElement,
  CustomDrawerBodyProps
>(
  (
    {
      onClick,
      children,
      className,
      onScroll,
      collapse,
      header,
    }: CustomDrawerBodyProps,
    ref: React.ForwardedRef<HTMLDivElement>
  ) => {
    const commonProps = {
      onClick,
      ref,
      onScroll,
    };

    if (collapse) {
      const collapseProps = typeof collapse === 'object' ? collapse : {};

      return (
        <div {...commonProps} className={cn(className, s.customDrawerBody)}>
          <Collapse
            {...collapseProps}
            className={s.customDrawerBody__content}
            ghost
          >
            <Collapse.Panel header={header} key="1">
              {children}
            </Collapse.Panel>
          </Collapse>
        </div>
      );
    }

    return (
      <div
        {...commonProps}
        className={cn(
          className,
          s.customDrawerBody,
          s.customDrawerBody__content,
          s.customDrawerBody__content_paddings
        )}
      >
        {children}
      </div>
    );
  }
);

export default CustomDrawerBody;
